module.exports = __webpack_public_path__ + "img/look_appli_pic1.223ad7e8.png";